import { render } from "./SkuInfo.vue?vue&type=template&id=4f6f45a6&scoped=true&ts=true"
import script from "./SkuInfo.vue?vue&type=script&lang=ts"
export * from "./SkuInfo.vue?vue&type=script&lang=ts"

import "./SkuInfo.vue?vue&type=style&index=0&id=4f6f45a6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6f45a6"]])

export default __exports__